import { useNavigate } from 'react-router-dom';

import { getClaim } from 'api/Claim';

import { showAlert } from 'components/shared/Alert/Alert';
import Popover from 'components/shared/Popovers/Popover/Popover';

const SuperbillActions = ({ data }) => {
  const navigate = useNavigate();
  let claim = data?.claim;

  const onClaimClick = async (e) => {
    if (!claim && data?.claim_id) {
      const res = await getClaim(navigate, { id: data.claim_id });
      claim = res?.claim;
    }

    if (claim?.id) {
      navigate(`/portal/charts/${data.patient_id}/billing/superbill/claim/${claim?.id}`);
    } else {
      showAlert({ color: 'danger', message: 'Claim not found or may have been deleted.' });
    }
    e?.stopPropagation();
  };

  const actionsOptions = [
    {
      label: 'View claim',
      icon: 'eye-mono',
      onClick: onClaimClick
    }
  ];

  return (
    <Popover
      className="flex h-full w-full items-center justify-center"
      position="left"
      isFixed
      icon="context-menu-horizontal"
      options={actionsOptions}
      isBorder={false}
    />
  );
};

export default SuperbillActions;
